/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const EdibleLiquid24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Edible liquid 24">
      <path
        fill="#4485DA"
        d="M1.368 3.314A2 2 0 0 1 3.343 1h17.314a2 2 0 0 1 1.975 2.314l-2.864 18A2 2 0 0 1 17.793 23H6.207a2 2 0 0 1-1.975-1.686l-2.864-18Z"
        className="Main"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M4.216 8.556a1 1 0 0 1 1.237-1.113l.661.17a5.099 5.099 0 0 0 3.642-.43 5.099 5.099 0 0 1 4.541-.107l.25.117a5.653 5.653 0 0 0 3.982.308l.038-.011a.96.96 0 0 1 1.218 1.059l-1.563 10.739A2 2 0 0 1 16.244 21H7.757a2 2 0 0 1-1.98-1.712L4.217 8.556Z"
        className="Details"
      />
      <path
        fill="#4485DA"
        d="M8.688 11.184a.997.997 0 0 1 1.359-.362l.714.41c.476.274.639.88.364 1.354l-.412.71a.997.997 0 0 1-1.36.363l-.713-.41a.989.989 0 0 1-.365-1.354l.413-.71Zm-.147 3.806a.995.995 0 0 1 1.22.7l.212.793a.99.99 0 0 1-.703 1.213l-.796.213a.995.995 0 0 1-1.219-.7l-.213-.793a.99.99 0 0 1 .703-1.214l.796-.213Zm3.136 1.888a.997.997 0 0 1 1.359-.362l.713.41a.99.99 0 0 1 .365 1.354l-.412.71a.997.997 0 0 1-1.36.363l-.713-.41a.989.989 0 0 1-.365-1.354l.413-.71Z"
        className="Main"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: EdibleLiquid24,
  md: EdibleLiquid24,
  lg: EdibleLiquid24,
  xl: EdibleLiquid24,
  xxl: EdibleLiquid24,
  xxxl: EdibleLiquid24,
};

export const EdibleLiquidIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'edible-liquid-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
